import type { StudioMarketingAsset, StudioMarketingFile, StudioMarketingIndex } from "@itaas/pep-contracts";

const STUDIO_INDEX_URL = "/assets/marketing/studio-index.json";

let cachedIndex: StudioMarketingIndex | null = null;

export async function getStudioMarketingIndex(): Promise<StudioMarketingIndex> {
  if (cachedIndex) return cachedIndex;
  const res = await fetch(STUDIO_INDEX_URL);
  if (!res.ok) {
    return { generatedAt: "", count: 0, assets: [] };
  }
  cachedIndex = (await res.json()) as StudioMarketingIndex;
  return cachedIndex;
}

export function getAssetsForProduct(
  index: StudioMarketingIndex,
  productSlug: string,
): StudioMarketingAsset[] {
  return index.assets.filter((a) => a.productSlug === productSlug);
}

export function getPrimaryFile(asset: StudioMarketingAsset): StudioMarketingFile | undefined {
  return asset.files.find((f) => f.variant === "primary") ?? asset.files[0];
}

const CAMPAIGN_LABELS: Record<string, string> = {
  "social-linkedin": "Post LinkedIn",
  "social-facebook": "Post Facebook",
  "social-story": "Story Instagram",
  "social-attendance-post": "Post — Appel numérique",
  "flyer-a5-direction": "Flyer A5 — Direction",
  "flyer-a5-parents": "Flyer A5 — Parents",
  "rollup-salon": "Roll-up salon",
  "teaser-hero": "Teaser vidéo",
  flyer: "Flyer",
  "deck-slides": "Présentation",
};

export function campaignLabel(campaignId: string): string {
  return CAMPAIGN_LABELS[campaignId] ?? campaignId;
}
